// extracted by mini-css-extract-plugin
export default {"content":"content-cPL1cntO","diceLand":"diceLand-K1Gc8tdf"};